import { all, fork } from 'redux-saga/effects';
import { listGalleryImagesSaga } from './list-gallery-images';
export function* rootSaga() {
    yield all([fork(listGalleryImagesSaga)]);
}
